<template>
  <div class="table-container">
    <table class="level-table">
      <thead>
      <tr>
        <th>Level</th>
        <th>Level 1<br>(35 Unit, 70 tiết học)</th>
        <th>Level 2<br>(35 Unit, 70 tiết học)</th>
        <th>Level 3<br>(35 Unit, 70 tiết học)</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td><strong>Nội dung</strong></td>
        <td>11 Topics nội dung quen thuộc, gần gũi về màu sắc, sở thích, đồ chơi,...</td>
        <td>11 Topics nội dung về động vật, cơ thể, quần áo, nhà cửa,...</td>
        <td>11 Topics nội dung về cảm xúc, sở thích, thời tiết, hình khối, tính từ mô tả về sự vật, sự việc</td>
      </tr>
      <tr>
        <td><strong>Số lượng từ vựng</strong></td>
        <td>Khoảng 35 từ vựng và mẫu câu</td>
        <td>Khoảng 70 từ vựng và mẫu câu</td>
        <td>Khoảng 100 từ vựng và mẫu câu</td>
      </tr>
      <tr>
        <td><strong>Thời gian học</strong></td>
        <td>1 năm</td>
        <td>1 năm</td>
        <td>1 năm</td>
      </tr>
      <tr>
        <td></td>
        <td>
          <button class="program-button" @click="openModal('https://static.babilala.vn/images/babischool/BABILALA SCHOOL CURRICULUM Level 1.pdf')">
            Khung chương trình
          </button>
        </td>
        <td>
          <button class="program-button" @click="openModal('https://static.babilala.vn/images/babischool/BABILALA SCHOOL CURRICULUM Level 2.pdf')">
            Khung chương trình
          </button>
        </td>
        <td>
          <button class="program-button" @click="openModal('https://static.babilala.vn/images/babischool/BABILALA SCHOOL CURRICULUM Level 3.pdf')">
            Khung chương trình
          </button>
        </td>
      </tr>
      </tbody>
    </table>

    <!-- PDF Modal -->
    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <div class="close-btn-wrapper">
          <v-btn @click="closeModal()" color="red" dark icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <iframe :src="pdfUrl" frameborder="0"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LevelTable",
  data() {
    return {
      showModal: false,
      pdfUrl: "",
    };
  },
  methods: {
    openModal(url) {
      const domain = window.location.hostname;
      if (domain.includes("lms-edusmart.") && url.includes("BABILALA SCHOOL CURRICULUM Level 1.pdf")) {
         url = 'https://static.babilala.vn/images/babischool/Edusmart curriculumn_Level 1 - Khung tong Edusmart Level 1.pdf';
      }
      this.pdfUrl = url;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.pdfUrl = "";
    },
  },
};
</script>

<style scoped>
.table-container {
  padding: 20px;
}

.level-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  font-family: Arial, sans-serif;
}

.level-table th,
.level-table td {
  border: 1px solid #ccc;
  padding: 12px;
  vertical-align: top;
}

.level-table thead {
  background-color: #eef5ff;
}

.program-button {
  background-color: #2196f3;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.program-button:hover {
  background-color: #1976d2;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  width: 80%;
  height: 90%;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

.modal-content iframe {
  width: 100%;
  height: 100%;
  border: none;
  position: relative;
  z-index: 1;
}

.close-btn-wrapper {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
}
</style>
